module.exports = __webpack_public_path__ + "static/media/no-fee_icon.9211a85a.svg";